import { useEffect } from 'react';

const useChartAutoResize = (chartRef, dependencies = []) => {
  useEffect(() => {
    const chart = chartRef.current?.getEchartsInstance?.();
    if (!chart || typeof window === 'undefined') return undefined;

    let frameId = null;
    let followUpTimeoutId = null;
    const resizeChart = () => {
      if (frameId !== null) {
        window.cancelAnimationFrame(frameId);
      }

      frameId = window.requestAnimationFrame(() => {
        frameId = null;
        chart.resize();
      });
    };

    resizeChart();
    followUpTimeoutId = window.setTimeout(resizeChart, 180);

    const dom = chart.getDom?.();
    const resizeTarget = dom?.parentElement || dom;
    const observer = typeof ResizeObserver !== 'undefined' && resizeTarget
      ? new ResizeObserver(() => resizeChart())
      : null;

    if (observer && resizeTarget) {
      observer.observe(resizeTarget);
    }
    window.addEventListener('resize', resizeChart);

    return () => {
      window.removeEventListener('resize', resizeChart);
      if (observer) observer.disconnect();
      if (frameId !== null) {
        window.cancelAnimationFrame(frameId);
      }
      if (followUpTimeoutId !== null) {
        window.clearTimeout(followUpTimeoutId);
      }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
};

export default useChartAutoResize;
